import { render, staticRenderFns } from "./BtnAcoesLeilao.vue?vue&type=template&id=259cbba3"
import script from "./BtnAcoesLeilao.vue?vue&type=script&lang=js"
export * from "./BtnAcoesLeilao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports